import { createContext } from 'react';
var AccordionContext = createContext({
    numbered: false
});
export default AccordionContext;
